import useSWR from 'swr'
import { get } from '@/utils/request'
import { ArticleType } from '@/utils/types'
import { commonSWROptions } from './useAdmin'

const fetchNews = () =>
  get('articles').then((res) => {
    if (res.ok) {
      return res.articles
    }
    return []
  })

const useNews = () => {
  return useSWR('news', () => fetchNews(), { ...commonSWROptions, fallbackData: [] }) as {
    data: ArticleType[]
    mutate: any
    isValidating: boolean
  }
}

// 资讯详情。数据在 Post(users/posts/:id),不是老的 articles 接口 ——
// 详情页早先照 articles 写,取不到东西,整页只剩一个日期。
export type NewsPost = {
  id: string
  title: string
  cover?: string
  body_html?: string
  published_at?: string
  created_at?: string
  owner_name?: string
  view_count?: number
  data?: { category?: string; source?: string; source_url?: string; view_count?: number }
}

// SWR key 必须带 id,否则在两篇资讯之间跳转会命中同一份缓存。
export const useNewsPost = (id?: string) =>
  useSWR(
    id ? ['news-post', id] : null,
    () => get(`users/posts/${id}`).then((res) => (res.ok ? res.post : null)),
    commonSWROptions
  ) as { data: NewsPost | null; mutate: any; isValidating: boolean }

export default useNews
